import { detectPlatform } from '@/utils'

export default {
  namespaced: true,
  state: {
    loaded: false,
    aside: {
      active: false
    },
    aside2: {
      active: false
    },
    catalog: {
      list: false
    },
    m_menu: {
      active: false
    },
    platform: detectPlatform()
  },
  actions: {
    setLoadState ({ commit, state }, newState) {
      commit('setLoadState', newState)
    }
  },
  mutations: {
    toggleAside (state, newState) {
      state.aside.active = (typeof newState === 'boolean') ? newState : !state.aside.active
      document.body.style.overflow = state.aside.active ? 'hidden' : ''
    },
    toggleAside2 (state, newState) {
      state.aside2.active = (typeof newState === 'boolean') ? newState : !state.aside2.active
      document.body.style.overflow = (state.aside.active || state.aside2.active) ? 'hidden' : ''
    },
    setLoadState (state, newState) {
      state.loaded = newState
    },
    catalogView (state, newState) {
      state.catalog.list = (typeof newState === 'boolean') ? newState : !state.catalog.list
    },
    toggleMobMenu (state, newState) {
      state.m_menu.active = (typeof newState === 'boolean') ? newState : !state.m_menu.active
    }
  },
  getters: {
    aside: state => state.aside,
    aside2: state => state.aside2,
    loaded: state => state.loaded,
    platform: state => state.platform,
    catalog: state => state.catalog,
    m_menu: state => state.m_menu
  }
}
